import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight, LogIn } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { AIOT_PATH, fetchCourse, loginUrl } from "@/lib/aiot";
import { LIVE_ONLY } from "@/lib/access";
import { DemoStrip } from "@/components/aiot/LandingSections";
import { LIVE_PATH } from "@/lib/simranLive";

// What guests and demo users see instead of Simran's live classes.
export const LiveLocked = ({ role }) => {
  const { L } = useLang();
  const [demos, setDemos] = useState([]);
  useEffect(() => { fetchCourse().then((c) => setDemos(c.demos)).catch(() => {}); }, []);
  return (
    <div className="bg-[#F3F8FB] min-h-screen" data-testid="live-locked">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-12">
        <div className="rounded-3xl bg-[#0B1F3A] text-white p-7 sm:p-10 flex flex-wrap items-center gap-6" data-testid="live-locked-banner">
          <span className="w-14 h-14 rounded-2xl bg-white/10 grid place-items-center shrink-0"><Lock className="w-6 h-6 text-[#5EEAD4]" /></span>
          <div className="flex-1 min-w-[240px]">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5EEAD4]">{L("Simran Ma'am · Live classes", "सिमरन मैम · लाइव क्लास")}</div>
            <p className="mt-2 text-lg sm:text-xl font-extrabold leading-snug" data-testid="live-locked-text">{L(...LIVE_ONLY)}</p>
            <p className="mt-1 text-sm text-slate-300">{role === "demo" ? L("Your account isn't enrolled yet. Live classes open once your AIoT Diploma application is approved.", "आपका अकाउंट अभी एनरोल नहीं है। AIoT डिप्लोमा आवेदन मंज़ूर होते ही लाइव क्लास खुलेंगी।")
              : L("Meanwhile, watch the free sample recorded classes below.", "तब तक नीचे दी गई फ़्री सैंपल रिकॉर्डेड क्लास देखिए।")}</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Link to={`${AIOT_PATH}#apply`} className="rounded-full bg-[#14B8A6] text-[#0B1F3A] px-6 h-12 inline-flex items-center gap-2 font-black hover:bg-white transition-colors" data-testid="live-locked-enroll">{L("Enroll now", "अभी एनरोल करें")}<ArrowRight className="w-4 h-4" /></Link>
            {role === "guest" && <Link to={loginUrl(LIVE_PATH)} className="rounded-full border border-white/30 px-5 h-12 inline-flex items-center gap-2 font-bold hover:bg-white/10 transition-colors" data-testid="live-locked-login"><LogIn className="w-4 h-4" />{L("Student sign in", "स्टूडेंट साइन इन")}</Link>}
          </div>
        </div>
      </div>
      <DemoStrip demos={demos} note={false} />
    </div>
  );
};
